export const INVITE_DEFAULTS = Object.freeze({
  EXPIRATION_DAYS: 7,
  MAX_USES: null,
});

export const INVITE_ERRORS = Object.freeze({
  NOT_FOUND: "INVITE_NOT_FOUND",
  EXPIRED: "INVITE_EXPIRED",
  MAX_USES_REACHED: "INVITE_MAX_USES_REACHED",
  INACTIVE: "INVITE_INACTIVE",
  ALREADY_ORG_MEMBER: "ALREADY_ORG_MEMBER",
  ALREADY_TEAM_MEMBER: "ALREADY_TEAM_MEMBER",
  INVALID_TEAM: "INVALID_TEAM",
});
